// Identitas tetap. Data kontak, harga, jadwal, statistik, testimoni & galeri dikelola dari Dashboard › Landing Page.
export const ACADEMY = { name: "Kholid Archery Academy", headCoach: "Kepala Pelatih KHA" };

export const DEFAULT_SITE = {
  address: "", city: "Jakarta", whatsapp: "", whatsapp_hours: "", email: "", registration_fee: 0,
  prices: { Anak: 0, Remaja: 0, Dewasa: 0 }, schedules: [], stats: [], testimonials: [], gallery: [],
};
